/**
 * @enum {Number}
 */
export const  APP_SHOW_MODE_ENUM = {
  DEVICE:0,
  SENCE:1,
  IFTTT:2
}

/**
 * @enum {Number}
 */
export const NEIGHBOR_GROUP = '0xFA00'


/**
 * @enum {Number}
 */
export const OTAUpgradeType = {
  /**
   * 单点GATT升级
   */
  GATT: 1,
  /**
   * Mesh升级
   */
  Mesh: 1 << 1,  //这种方式原生不关心
  /**
   * AP升级
   */
  AP: 1 << 2,
  /**
   * Obus升级
   */
  Obus: 1 << 3,  //这种方式原生不关心

  /**
   * 低功耗 GATT
   */
  LEGATT: 1 << 4, // 低功耗 GATT

  /**
   * BLE 转 DALI
   */
  BLE_DALI: 1 << 5, // BLE 转 DALI 导轨控制器下的导轨灯升级

  SIGMESH_OTA: 1 << 6,

  /**
 * BLE 转 DALI
 */
  BLE_DALI_2: 1 << 7, // BLE 转 DALI 
  /**
   * 云端发送通知给设备升级，支持批量升级(通知设备直升)
   */
  IOT_NOTIFICATION: 1 << 8,
}

/**
 * @enum {Array}
 *  华为lite关联的面板SKU
 * */

export const LITE_PANEL_CLASSSKU = ['0x0200031C','0x00100518','0x00100517']


/**
 * @enum {Number}
 */
export const APPTYPE = {
  web: 4
}

/**
  * {1 | 2 | 4 } 1:SSid 更换引导; 2:被动识别; 4:综合引导
 */
export const CONFIGTYPE = {
  composite: 4,
  passivity: 2
}


/* 
*  识别类型: 0主动识别 1被动识别 2状态识别 -1未知
*/

export const  IDENTIFY_TYPE = {
  //主动识别
  ACTIVE: 0,
  //被动识别
  PASSIVE: 1,
  //状态识别
  STATUS: 2,
  //未知
  UNKNOWN: -1
}



/**
 * Tab 
 */

export const MONITOR_TAB = {
  DEVICE:'device',
  POWER:'power',
  SPACE:'space'
}


/**
 * 设备角色
 */
export  const  DEVICE_ROLE = {
  TianMu:1,   //天幕设备
  Default:0
}



// 设备设置类型
export const DEVICE_SET_TYPE ={
  SET_CLO: 256, // 设置CLO
  SET_POWER_ON_STATE: 4, // 设置批量上电
  SET_LAMP_GRADUAL: 8, // 设置灯具渐变开关以及时长
  SET_SENSOR_EXT_TIME: 2, // 设置传感器延时
  SET_SENSOR_SENSITIVE: 512, //512 // 设置传感器灵敏度
  SET_DALSULV: 8192,
  SET_BATCH_RESET: 16, // 批量复位
  SET_LINKAGE_PANEL: 32, // 设置联动面板
  SET_POWER_MODEL: 1, // 设置灯具最大功率
  SET_DEVICE_PROTOCOL:64, //设备协议
  SET_ZHAGA_PROTOCOL: 4096,
  SET_ChannelRename: 999. //批量设置通道名称 这个999 是自己定义的，切记
} 
/* 
  SDL的cxcy色盘
  为了兼容多个版本valueType
*/
export const UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY = ['UIControl_CXCY_Color_Multiple_Choose','UIControl_CXCY_Color_Multiple_ChooseV2', 'UIControl_Color_RGB_WithMode']
export const UICONTROL_CX_CY_WithMode_ARRAY = ['UIControl_Color_CX_CY_WithMode','UIControl_Color_CX_CY_WithModeV2']

export const PROJECTTYPE_ENUM = {
  Haidilao: 2561,
  Agriculture: 265
};

//路由-菜单高亮映射表
export const routeHighlightMap = {
  '/networkCheck': '/install', // networkCheck路由高亮install菜单
};

